import React, { useEffect } from "react";
import styles from "./index.module.scss";
import { CloseSvg } from "@/assets/icons";
import { FTFlex } from "../flex";
import { Checkbox } from "../checkbox/checkbox";
import { Button } from "../button";
import { useTranslation } from "react-i18next";

interface CommonConfirmModalProps {
  title: string;
  okText?: string;
  cancelText?: string;
  open?: boolean;
  close?: () => void;
  afterClose?: () => void;
  onOk?: (showAgain: boolean) => void;
  onCancel?: (showAgain: boolean) => void;
}

export default function CommonConfirmModal(props: CommonConfirmModalProps) {
  const { open, close, afterClose, title, okText, cancelText, onCancel, onOk } = props;
  const [isShow, setIsShow] = React.useState(false);
  const { t } = useTranslation();
  const handleClose = () => {
    onCancel?.(isShow);
    close?.();
    // afterClose?.();
  };

  const handleOk = () => {
    onOk?.(isShow);
    close?.();
  };
  useEffect(() => {
    if (!open && afterClose) {
      afterClose();
    }
  }, [open, afterClose]);
  return (
    <div className={styles.confirmModal} hidden={!open}>
      <div className={styles.mask}></div>
      <div className={styles.content}>
        <div className={styles.close} onClick={handleClose}>
          <CloseSvg />
        </div>
        <div className={styles.title}>{title}</div>
        <FTFlex className={styles.body} justify="space-between" align="center">
          <div className={styles.body_right}>
            <Button onClick={handleClose}>
              {cancelText || t("confirm_default_btn_cancel")}
            </Button>
            <Button primary={true} onClick={handleOk}>
              <span>{okText || t("confirm_default_btn_ok")}</span>
            </Button>
          </div>
        </FTFlex>
      </div>
    </div>
  );
}
